import { forkJoin, map, Observable } from 'rxjs';
import { SiteDto, SiteLocation } from './site.model';
import { Location } from '../location/location.model';
import { SiteRepository } from './site.repository';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable()
export class SiteRepositoryHttp extends SiteRepository {
  private readonly http = inject(HttpClient);
  private readonly sitesUrl = `${environment.apiBaseUrl}/sites`;
  private readonly locationsUrl = `${environment.apiBaseUrl}/locations`;

  getById(siteId: number): Observable<SiteLocation | null> {
    return this.http.get<SiteLocation>(`${this.sitesUrl}/${siteId}`);
  }

  listAll(): Observable<SiteDto[]> {
    return this.http.get<SiteDto[]>(this.sitesUrl);
  }

  listSitesWithLocations(): Observable<SiteLocation[]> {
    const sites = this.http.get<SiteDto[]>(this.sitesUrl);
    const locations = this.http.get<Location[]>(this.locationsUrl);

    return forkJoin({ sites: sites, locations: locations }).pipe(
      map(({ sites, locations }) =>
        sites.map((site) => ({
          ...site,
          locations: locations.filter((loc) => loc.siteId === site.id),
        }))
      )
    );
  }
}
